import Swiper from "swiper";

export default function initCardsSection() {
   const swiper = new Swiper(".advantage-cards-swiper-container", {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: true,
      breakpoints: {
         768: {
            slidesPerView: 2,
         },
         992: {
            slidesPerView: 3,
         },
         1600: {
            slidesPerView: 4,
         },
      }
   });

   const swiperActionPrev = document.getElementById("advantage-cards-control-prev");
   swiperActionPrev?.addEventListener("click", () => swiper.slidePrev());
   const swiperActionNext = document.getElementById("advantage-cards-control-next");
   swiperActionNext?.addEventListener("click", () => swiper.slideNext());
}